module.exports = __webpack_public_path__ + "img/ja_jp.9813a270.png";